import { GAME_NAME, TRACK_EVENTS, TRACK_SCREENS } from 'game/tracking/stats.js';

export class Tracking {
  constructor(debug = false) {
    this.startTime = Date.now();
    this.debug = debug;
    this.screenName = false;
    this.roundName = false;
    this.objectClickCount = 0;
    this.trackPrompt = false;
    window.addEventListener('unload', () => {
      this.quitGame();
    });
  }

  _trackDataLayer(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  _trackInternal(event, options) {
    const opts = {
      event,
      gameName: GAME_NAME,
      language: 'English',
      timestamp: Date.now(),
      ...options,
    };
    if (!options.screenName && this.screenName) {
      opts.screenName = this.screenName;
    }
    if (!options.roundName && this.roundName) {
      opts.roundName = this.roundName;
    }
    if (this.debug) {
      // console.log(`[TRACK] ${opts.event}`);
      console.table(opts);
    }
    if (JW_WATCH) return;
    this._trackDataLayer(opts);
  }

  // api
  track(event, opts) {
    this._trackInternal(event, opts);
  }

  closeGame() {
    // fired when user clicks the 'x'
    const duration = Math.floor((Date.now() - this.startTime) / 1000);
    this.track(TRACK_EVENTS.GAME_QUIT, { duration });
  }

  quitGame() {
    // this.track(TRACK_EVENTS.GAME_INTERACTION, { objectName: 'Total Objects' });
  }

  trackPromptStart() {
    if (this.trackPrompt) return;
    this.track(TRACK_EVENTS.GAME_TIMEOUT_PLAY, {});
    this.trackPrompt = true;
  }

  trackPromptStop() {
    if (!this.trackPrompt) return;
    this.track(TRACK_EVENTS.GAME_TIMEOUT_REENGAGE, {});
    this.trackPrompt = false;
  }

  setScreenName(id) {
    this.screenName = id;
  }

  setRoundName(id) {
    this.roundName = id;
  }

  startComponent(component) {
    this.componentStartTime = Date.now();
    this.track(TRACK_EVENTS.GAME_COMPONENT_START, { ...component });
  }

  completeComponent(component) {
    const duration = Math.floor((Date.now() - this.componentStartTime) / 1000);
    this.track(TRACK_EVENTS.GAME_COMPONENT_COMPLETE, { ...component, duration });
  }

  startRound(roundNumber) {
    this.roundStartTime = Date.now();
    this.track(TRACK_EVENTS.GAME_ROUND_START, { roundNumber });
  }

  completeRound(roundNumber) {
    const duration = Math.floor((Date.now() - this.roundStartTime) / 1000);
    this.track(TRACK_EVENTS.GAME_ROUND_COMPLETE, { roundNumber, duration });
  }

  completeGamePlay(playthroughNumber) {
    const duration = Math.floor((Date.now() - this.roundStartTime) / 1000);
    this.track(TRACK_EVENTS.GAME_PLAYTHROUGH_COMPLETE, { playthroughNumber, duration });
  }

  destroy() {
    this.plugin = null;
    this.stats = null;
  }
}
